export type Theme = 'dark' | 'light' | 'oled' | 'division';

const KEY = 'divcalc:theme';
const THEMES: Theme[] = ['dark', 'light', 'oled', 'division'];

class ThemeState {
  current = $state<Theme>('dark');

  init() {
    /* Forced dark theme — light/oled/division disabled for now (broken UX). */
    this.current = 'dark';
    try { localStorage.setItem(KEY, 'dark'); } catch { /* ignore */ }
    this.apply();
  }

  set(t: Theme) {
    this.current = t;
    try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
    this.apply();
  }

  cycle() {
    const idx = THEMES.indexOf(this.current);
    this.set(THEMES[(idx + 1) % THEMES.length]);
  }

  private apply() {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute('data-theme', this.current);
  }
}

export const theme = new ThemeState();
export const THEME_LIST = THEMES;
